import React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { Link } from 'react-router-dom';
import { MeatballMenu, PromptConfirmationModal } from 'ui';
import { isDisabled } from 'app/infrastructure/data/date';
import { Tag } from 'app/components/tag';
import { routeConstants } from 'app/routes/route-constants';
import { ListItemProps } from 'app/area/import-sets-administration/list/types-store';
import styles from './list-item.scss';
import { CodetableItemLoader } from 'app/area/shared/codetable/item/codetable-item-loader';

export const ListItem: React.FC<ListItemProps> = ({
  item, deleting, translation, deleteImportSet
}) => {

  const handleDuplicate = () => {
    navigate.to({
      pathname: routeConstants.importSetDuplicateFor(item.value)
    });
  }

  const handleMissingCodes = () => navigate.toImportMappingsList(item.value);

  const handleDelete = () => {
    deleteImportSet(
      item.value,
      item.description,
      translation.import_set_deleted
    );
  };

  return <div className={styles.importSetRow}>
    {!deleting
      ? <Link className={styles.importSetName} to={routeConstants.importSetEditFor(item.value)}>
        {item.description}
      </Link>
      : <div className={styles.importSetName}>
        {item.description}
        <CodetableItemLoader />
      </div>}
    {isDisabled(item.disabled)
      ? <Tag className={styles.disabledTag}>
        {translation.disabled}
      </Tag>
      : null}
    <div className={styles.meatballContainer}>
      {item.value !== 0 && !deleting
        ? <MeatballMenu
          id={`meatball-${item.value}`}
          className={styles.meatball}>
          <li>
            <button type="button"
              className="dropdown-item"
              onClick={handleDuplicate}>
              {translation.duplicate_import_set}
            </button>
          </li>
          <li>
            <button type="button"
              className="dropdown-item"
              onClick={handleMissingCodes}>
              {translation.import_codes}
            </button>
          </li>
          <li>
            <PromptConfirmationModal
              title={translation.delete_import_set}
              description={translation.delete_confirmation}
              continueText={translation.delete_import_set}
              cancelText={translation.cancel}
              onContinue={handleDelete}>
              <button type="button"
                className="dropdown-item"
                disabled={deleting}>
                {translation.delete_import_set}
              </button>
            </PromptConfirmationModal>
          </li>
        </MeatballMenu> : null}
    </div>
  </div>;
};
